import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

import FileTag from "@mapmycustomers/shared/types/entity/FileTag";
import User from "@mapmycustomers/shared/types/User";

import CoachingFile from "@app/scene/dashboard/types/CoachingFile";

export interface CoachingFilesFilter {
  subjectUserId: User["id"];
  tagIds?: FileTag["id"][];
}

export const fetchCoachingFiles = createAsyncAction(
  "@dashboard/coaching/files/fetch/request",
  "@dashboard/coaching/files/fetch/success",
  "@dashboard/coaching/files/fetch/failure"
)<CoachingFilesFilter, CoachingFile[], void>();

// Single-row resolve at chip-click time. Members lack access to the pool LIST
// for files an Owner/Manager attached to their note, but the BE permits the
// single-record GET on a file already referenced by a note they can read —
// so click-to-preview goes through this action instead of the pool.
export const fetchCoachingFile = createAction("@dashboard/coaching/files/fetchOne")<{
  coachingFileId: CoachingFile["id"];
  onFailure?: () => void;
  onSuccess: (file: CoachingFile) => void;
}>();

export const uploadCoachingFiles = createAsyncAction(
  "@dashboard/coaching/files/upload/request",
  "@dashboard/coaching/files/upload/success",
  "@dashboard/coaching/files/upload/failure"
)<{ files: (Blob | File)[]; subjectUserId: User["id"] }, CoachingFile[], void>();

export const updateCoachingFileTags = createAsyncAction(
  "@dashboard/coaching/files/updateTags/request",
  "@dashboard/coaching/files/updateTags/success",
  "@dashboard/coaching/files/updateTags/failure"
)<{ id: CoachingFile["id"]; tagIds: FileTag["id"][] }, CoachingFile, CoachingFile["id"]>();

export const deleteCoachingFile = createAsyncAction(
  "@dashboard/coaching/files/delete/request",
  "@dashboard/coaching/files/delete/success",
  "@dashboard/coaching/files/delete/failure"
)<{ id: CoachingFile["id"] }, { id: CoachingFile["id"] }, CoachingFile["id"]>();

export type CoachingFilesActions = ActionType<
  | typeof deleteCoachingFile
  | typeof fetchCoachingFile
  | typeof fetchCoachingFiles
  | typeof updateCoachingFileTags
  | typeof uploadCoachingFiles
>;
